import React from 'react'

export const IconRightLong = (props = {}) => {
	const {size = 17, imgSize= 17, fill = "white"} = props
	const k = 16.0 / 17.0
	return <>
		<svg xmlns="http://www.w3.org/2000/svg"
				 width={`${size}px`}
				 height={`${k * size}px`}
				 viewBox={`0 0 ${imgSize} ${k * imgSize}`}
				 fill="none"
		>
			<g clipPath="url(#clip0_1_7519)">
				<path
					d="M9.33324 2.88417L14.1364 7.68731H1.41034L1.41034 8.68763L14.1364 8.68763L9.33324 13.4908L10.0403 14.1979L16.0508 8.18747L10.0403 2.17707L9.33324 2.88417Z"
					fill={fill} fillOpacity="0.6"
				/>
			</g>
			<defs>
				<clipPath id="clip0_1_7519">
					<rect width={`${size - 1}px`} height={`${size - 1}px`} fill={fill} transform="translate(0.666992)"/>
				</clipPath>
			</defs>
		</svg>
	</>
}
